import { DomainActionEnum, DomainSearchError } from '../../types';
export const ModalsMap = {
  [DomainSearchError.DOMAIN_TAKEN_IN_WIX]: DomainSearchError.DOMAIN_TAKEN_IN_WIX,
  [DomainSearchError.ALREADY_ASSIGNED]: DomainSearchError.ALREADY_ASSIGNED,
  [DomainSearchError.LANGUAGE_CODE_SUBDOMAIN]: DomainSearchError.LANGUAGE_CODE_SUBDOMAIN,
  [DomainSearchError.UPGRADE_REQUIRE_CONNECT]: DomainSearchError.UPGRADE_REQUIRE_CONNECT,
  [DomainActionEnum.upgradePaywall]: DomainActionEnum.upgradePaywall,
  [DomainActionEnum.upgradePaywallModal]: DomainActionEnum.upgradePaywallModal,
  [DomainActionEnum.transfer]: DomainActionEnum.transfer,
  [DomainSearchError.GOOGLE_CUSTOMER_EXISTS]: DomainSearchError.GOOGLE_CUSTOMER_EXISTS,
  [DomainSearchError.GOOGLE_RESTRICTED_WORD]: DomainSearchError.GOOGLE_RESTRICTED_WORD
};
//# sourceMappingURL=Modals.js.map